/*
How to use toggleItems ?

You need 3 class ['toggle-item', 'toggle-title', 'toggle-content']

Example(
  <div class="toggle-item">
    <div class="toggle-title">title</div>
    <div class="toggle-content">content</div>
  </div>
)

In your js file you need to import toggleItems:
  import { toggleItems } from '@src/components/toggleItems';

Select every items you need to toggle:
  const $items = $('.footer-main-links-cols.toggle-item');

Then use toggleItems with all items in argument:
  toggleItems($items);
*/

import { Screens } from '@tailwindConfig/screens.config';

const OpenClass = 'open';

const collapseSection = (element) => element.css('height', '');

const expandSection = (element) => {
  const sectionHeight = element.prop('scrollHeight');
  element.css('height', `${sectionHeight}px`);
};

export const toggleItems = ($items, tablet = false, scrollTo = true, noBreakpoint = false, firstItemOpen = false) => {
  let contentOpen;
  let screenChanged = null;
  const breakpoint = noBreakpoint ? window.matchMedia('(min-width: 0px)') : window.matchMedia(`(max-width: ${tablet ? Screens.lg.min : Screens.md.min})`);

  const scrollToElement = (index, $firstItemTitle) => {
    const headerHeight = $('header').height();
    let previousItemsTitleHeight = 0;
    $items.each(function (number) {
      if (number >= index) return;
      const $itemTitle = $(this).find('.toggle-title');
      previousItemsTitleHeight += $itemTitle.prop('scrollHeight');
    });
    $('html, body').animate({
      scrollTop: $firstItemTitle.offset().top + previousItemsTitleHeight - headerHeight
    }, 500);
  };

  // Automatically close opened items
  function toggleMobileItem(event, $item, index, $firstItemTitle) {
    event.preventDefault();
    const $content = $item.find('.toggle-content');

    if (!contentOpen) {
      expandSection($content);
      $item.addClass(OpenClass);
      contentOpen = $content;
    } else if ($content.is(contentOpen)) {
      collapseSection($content);
      $item.removeClass(OpenClass);
      contentOpen = null;
    } else {
      collapseSection(contentOpen);
      contentOpen.parent('.toggle-item').removeClass(OpenClass);
      expandSection($content);
      $item.addClass(OpenClass);
      contentOpen = $content;
    }

    scrollTo && scrollToElement(index, $firstItemTitle);
  };

  function bindToggleMobileItems() {
    // return if screen dont change
    if (screenChanged != null && screenChanged === breakpoint.matches) return;

    const $firstItemTitle = $items.eq(0).find('.toggle-title');
    if (breakpoint.matches) {
      // bind toggle items on mobile
      $items.each(function (index) {
        const $item = $(this);
        const $title = $item.find('.toggle-title');
        $title.on('click', (event) => toggleMobileItem(event, $item, index, $firstItemTitle));
      });
    } else {
      // unbind/reset toggle items on desktop
      $items.each(function () {
        const $title = $(this).find('.toggle-title');
        $title.off();
        collapseSection($(this).find('.toggle-content'));
        $(this).removeClass(OpenClass);
        contentOpen = null;
      });
    }
    screenChanged = breakpoint.matches;
  };

  // initialize
  if (firstItemOpen) {
    const $firstItem = $items.eq(0);
    const $content = $firstItem.find('.toggle-content');
    expandSection($content);
    $firstItem.addClass('open');
    contentOpen = $content;
  }
  bindToggleMobileItems();

  let timer = null;
  $(window).on('resize', function () {
    clearTimeout(timer);
    timer = setTimeout(() => bindToggleMobileItems(), 100);
  });
};
